var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  viewBox: "0 0 16 20",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 20,
  rx: 4,
  fill: "#F4F4F5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 4,
  width: 1.5,
  height: 6,
  rx: 0.75,
  transform: "rotate(90 13 4)",
  fill: "#16181B"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 7,
  width: 1.5,
  height: 6,
  rx: 0.75,
  transform: "rotate(90 13 7)",
  fill: "#16181B"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 11,
  width: 3,
  height: 2,
  rx: 1,
  transform: "rotate(90 13 11)",
  fill: "#16181B"
})));
export default SvgCloset;